// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HVnMX","col":"styles_col__7M6qQ"};